import React, { Component } from "react";
// import MainProfile from './MainProfile.jsx';
import InitialMainProfile from "./InitialMainProfile.jsx";
import { withStyles } from "@material-ui/core/styles";
import { compose } from "redux";
import { Button, TextField } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import LogoutAlert from "../../components/Alert/LogoutAlert.jsx";
import UpdateProfile from "./UpdateProfile.jsx";
import * as actions from "../../actions/index.js";
import { FormattedMessage, injectIntl } from "react-intl";
import {
  ROLE_CUSTOMER,
  ROLE_PROVIDER,
  SERVER_URL,
} from "../../utils/config/constants.js";
import { withRouter } from "react-router-dom";
import { AccountBalanceWallet, SearchIcon } from "@material-ui/icons";
import { connect } from "react-redux";
import {
  Clear,
  Add,
  Remove,
  ArrowLeft,
  ArrowRight,
  ArrowForward,
  ArrowBack,
  Category,
  AccessTime,
} from "@material-ui/icons";
import ContentLoader from "react-content-loader";
import { getCookies } from "../../utils/getToken.js";
import Axios from "axios";
import NavbarNew from "../../components/NavBarNew/NavbarNew.js";

class ManageBookingsCategoryScreenNew extends Component {
  constructor(props) {
    super(props);

    this.state = {
      bookingListDataPrev: this.props.history.location.state.bookingListData,
      bookingListHeadingPrev: this.props.history.location.state.heading,
    };
  }
  componentDidMount() {
    console.log("bookingListDataPrev", this.state.bookingListDataPrev);
  }

  componentWillUnmount() {}

  renderLoading = (index) => {
    return (
      <div style={{ width: 250, margin: 10, height: 250 }} key={index}>
        <ContentLoader
          height={200}
          width={200}
          speed={2}
          borderRadius={5}
          primaryColor="#f3f3f3"
          secondaryColor="#ecebeb"
        >
          <rect x="0" y="0" rx="0" ry="0" width="200" height="160" />
          <rect x="100" y="100" rx="0" ry="0" width="200" height="10" />
        </ContentLoader>
      </div>
    );
  };

  roundUpTransaction = (transaction) => {
    let roundUpValue = transaction.toString();

    if (roundUpValue.includes(".")) {
      return Number(transaction).toFixed(2);
    } else {
      return Number(transaction);
    }
  };

  onDetailsPressed = (booking) => {
    console.log("booking status on details clickedd", booking.status);
    if (booking.status == "revised-price") {
      this.props.history.push("/user/revise_price_request", {
        bookingDetailsData: booking,
      });
    } else {
      this.props.history.push("/user/bookings_details", {
        bookingDetailsData: booking,
      });
    }
  };

  renderBookingListCard = (booking) => {
    var monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    let originalDate = booking.booking_date;
    let year = originalDate.substring(0, 4);
    let month = Number(originalDate.substring(5, 7)) - 1;
    let date = originalDate.substring(8, 10);
    let formattedDate = monthNames[month] + " " + date + ", " + year;

    return (
      <div
        style={{
          backgroundColor: "#ddd",
          marginBottom: 20,
          boxShadow: "1px 1px 20px #ddd",
          backgroundColor: "#fff",
          padding: 20,
          paddingTop: 30,
          borderRadius: "10px",
        }}
      >
        <div
          id="height"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            id="Auto"
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <img
              id="car_img"
              src={booking.taskData.image.medium}
              style={{ height: "8rem", width: "8rem", borderRadius: 100 }}
            />
            <div
              style={{
                marginLeft: 15,
              }}
            >
              <p
                id="car_cleaning"
                style={{
                  color: "#0078ff",
                  fontSize: 25,
                  fontWeight: "bold",
                }}
              >
                {booking.taskData.full_name.service}
              </p>
              <p
                id="car_cleaning1"
                style={{
                  // color: 'green',
                  fontSize: 20,
                }}
              >
                Booking# {booking.booking_number}
              </p>
            </div>
          </div>
          {booking.status === "no-provider" && (
            <div
              id="height1"
              style={{
                marginTop: "-5rem",
              }}
            >
              <p
                id="car_cleaning1"
                style={{
                  color: "orange",
                  fontSize: 15,
                  fontWeight: "bold",
                  fontSize: 20,
                }}
              >
                No Provider Available
              </p>
            </div>
          )}
          {booking.status === "rescheduled-provider" && (
            <div
              id="height1"
              style={{
                marginTop: "-5rem",
              }}
            >
              <p
                style={{
                  color: "orange",
                  fontSize: 15,
                  fontWeight: "bold",
                  fontSize: 20,
                }}
              >
                Rescheduled
              </p>
            </div>
          )}
          {booking.status === "completed" && (
            <div
              id="height1"
              style={{
                marginTop: "-5rem",
              }}
            >
              <p
                style={{
                  color: "orange",
                  fontSize: 15,
                  fontWeight: "bold",
                  fontSize: 20,
                }}
              >
                Pending Action
              </p>
            </div>
          )}
          {booking.status === "no-show" && (
            <div
              id="height1"
              style={{
                marginTop: "-5rem",
              }}
            >
              <p
                style={{
                  color: "orange",
                  fontSize: 15,
                  fontWeight: "bold",
                  fontSize: 20,
                }}
              >
                Provider No Show
              </p>
            </div>
          )}
          {booking.status === "revised-price" && (
            <div
              id="height1"
              style={{
                marginTop: "-5rem",
              }}
            >
              <p
                style={{
                  color: "orange",
                  fontSize: 15,
                  fontWeight: "bold",
                  fontSize: 20,
                }}
              >
                Revised Price
              </p>
            </div>
          )}
          {booking.status === "closed" && (
            <div
              id="height1"
              style={{
                marginTop: "-5rem",
              }}
            >
              <p
                style={{
                  color: "green",
                  fontSize: 15,
                  fontWeight: "bold",
                  fontSize: 20,
                }}
              >
                Completed
              </p>
            </div>
          )}
          {booking.status === "denied" && (
            <div
              id="height1"
              style={{
                marginTop: "-5rem",
              }}
            >
              <p
                style={{
                  color: "orange",
                  fontSize: 15,
                  fontWeight: "bold",
                  fontSize: 20,
                }}
              >
                Pending Approval
              </p>
            </div>
          )}
        </div>
        <div
          id="car_cleaning2"
          style={{
            marginLeft: 20,
            marginTop: 15,
          }}
        >
          <p
            id="car_cleaning1"
            style={{
              fontSize: 20,
            }}
          >
            Task Description:{" "}
            {booking.taskData.description
              ? booking.taskData.description
              : "No Description found"}
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              <p
                id="car_cleaning1"
                style={{
                  fontSize: 20,
                  fontWeight: "bold",
                }}
              >
                Schedule Date: {formattedDate}
              </p>
              <p
                id="car_cleaning1"
                style={{
                  fontSize: 20,
                  fontWeight: "bold",
                }}
              >
                Total Price - ${this.roundUpTransaction(booking.booking_value)}
              </p>
            </div>
            <p
              id="car_cleaning1"
              style={{
                backgroundColor: "#0078ff",
                padding: "15px 20px",
                padding: "10px 25px",
                borderRadius: 50,
                color: "white",
                marginBottom: 0,
                fontSize: 17,
                fontWeight: "bold",
                cursor: "pointer",
              }}
              onClick={() => this.onDetailsPressed(booking)}
              // onClick={()=> this.props.history.push('/user/revise_price_request',
              //     { bookingDetailsData: booking })
              // }
            >
              Details
            </p>
          </div>
        </div>
      </div>
    );
  };

  render() {
    var summaryCard = {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: 20,
      boxShadow: "2px 1px 5px #ddd",
      backgroundColor: "#fff",
      padding: 20,
      paddingTop: 30,
      alignItems: "center",
      // textAlign: 'center',
      cursor: "pointer",
      borderRadius: 5,
    };
    var summaryCardLeft = {
      display: "flex",
    };
    // console.log(">>>>this.state.serviceDataPrev", this.state.serviceDataPrev);
    // console.log(this.props,' in profileDashboard')

    return (
      <div
        className="tz-2-com tz-2-main h4-padding"
        style={{
          // height: '107vh',
          overflowY: "scroll",
        }}
      >
        <div style={{ paddingBottom: "25px" }} className="db-list-com">
          <div className="row">
            <div className="col-md-12">
              <NavbarNew
                title="Booking list"
                goback={() => this.props.history.goBack(null)}
              />
              <div>
                <p
                  id="booking_status"
                  style={{
                    fontSize: 30,
                    marginBottom: 20,
                  }}
                >
                  Booking Status - {this.state.bookingListHeadingPrev}
                </p>
                <div>
                  {this.state.bookingListDataPrev
                    // .sort((a,b)=> {
                    //     return new Date(a.booking_start_datetime).getTime() - new Date(b.booking_start_datetime).getTime()
                    // })
                    .map((item) => {
                      return this.renderBookingListCard(item);
                    })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ settings, categories, providers }) => {
  return {
    settings,
    categoryData: categories.categoryData,
    featuredProviderList: providers.featuredProviderList,
    featuredProviderLoader: providers.featuredProviderLoader,
  };
};
const composedProfile = compose(
  connect(
    mapStateToProps,
    actions
  )
);
export default composedProfile(withRouter(ManageBookingsCategoryScreenNew));



// WEBPACK FOOTER //
// ./src/views/User/ManageBookingsCategoryScreenNew.jsx